import * as actionType from "../userActionType";

export const LoginAction = (payload) => {
  return {
    type: actionType.LOGIN,
    payload,
  };
};

export const clearUserAction = () => {
  return {
    type: actionType.CLEAR_USER,
  };
};


